export default __webpack_public_path__ + "static/media/sport-utility-vehicle.bb510238.png";